export default __webpack_public_path__ + "static/media/1973.5fa57b81.png";